import PropTypes from 'prop-types';

import DimensionsStore from '../stores/DimensionsStore';
import connectToStores from '../helpers/connectToStores';


export function ResponsiveRender({
    forceRender, height, width, minHeight,
    minWidth, maxHeight, maxWidth, children
}) {

    if (maxHeight && maxHeight < minHeight) {
        console.warn(`maxHeight ${maxHeight} is less than minHeight ${minHeight} so this will never render`);
    }
    if (maxWidth && maxWidth < minWidth) {
        console.warn(`maxWidth ${maxWidth} is less than minWidth ${minWidth} so this will never render`);
    }

    if (!forceRender && (
        minHeight > height ||
        minWidth > width ||
        (maxHeight && (maxHeight < height)) ||
        (maxWidth && (maxWidth < width)))) {
        return null;
    }
    return children;
}

ResponsiveRender.propTypes = {
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    minWidth: PropTypes.number,
    minHeight: PropTypes.number,
    maxWidth: PropTypes.number,
    maxHeight: PropTypes.number,
    forceRender: PropTypes.bool,
    children: PropTypes.node
};

ResponsiveRender.defaultProps = {
    minWidth: 0,
    maxWidth: 0,
    minHeight: 0,
    maxHeight: 0,
    forceRender: false
};

export default connectToStores([ DimensionsStore ], () => DimensionsStore.getAll().toJS())(ResponsiveRender);
